__turbopack_context__.v({
  "spinner": "styles-module__PPv3oW__spinner",
});
